import styled from 'styled-components';
import { Text14Light } from '../../utils/Text/Text.styles';
import { Button } from '../../utils/Button/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 2.8rem;
`;

export const Subtitle = styled(Text14Light)`
  opacity: 0.67;
`;

export const VoiceNameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4.6rem;
  border-radius: 12px;
  border: 1px solid #d2d6db;
  padding: 0.8rem;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    cursor: pointer;
  }
`;

export const VoiceUploadContainer = styled.div`
  display: flex;
  gap: 1.4rem;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

export const ContinueButton = styled(Button)`
  margin-top: 3rem;
  width: 24rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
    width: 100%;
    margin-bottom: 3rem;
  }
`;

export const BackContainer = styled.div`
  position: absolute;
  top: 2.4rem;
`;
